/** Where a tour stands. Here rather than beside the tour schemas so a screen can list them without
 * loading zod. */
export const TOUR_STATUSES = ["scheduled", "completed", "cancelled", "no_show"] as const;
